import { AppState } from '../redux.model';

export const getUserId = (state: AppState) => state.User.currentUser?.id;

// P40-61939: role_ids believed to grant workspace:read on crn:system, which is what
// GET /v2/workspaces requires. Derived from diffing the roles payload of a user who 403s
// against one who does not; pending confirmation from Platform. A wrong or stale entry here
// is not fatal, getWorkspaces falls back to /v2/accounts/workspaces on 403.
export const SYSTEM_WORKSPACE_READERS = ['SupportAgent', 'ProtectorAdminCC', 'ProtectorAdminETDENG'];

export const selectCanReadSystemWorkspaces = (state: AppState): boolean => {
  const roles = state.User?.rbacRoles;
  // Roles are only loaded on the RBAC branch of handleLoadUserMe, so legacy and flag-off users
  // never get them. Treat unknown as permitted and let the 403 fallback decide, otherwise those
  // users would silently drop to the narrow account list with no error to explain it.
  if (!roles) return true;
  return roles.some(role => SYSTEM_WORKSPACE_READERS.includes(role.role_id));
};
